import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

interface HotWorksListProps {
  items: Work[];
}

export default function HotWorksList({ items }: HotWorksListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-200 bg-background-100">
        <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-fire-fill text-accent-500" />
          热门作品推荐
        </h3>
        <Link to="/category/works" className="text-xs text-primary-600 hover:text-primary-700 whitespace-nowrap">
          全部
        </Link>
      </div>
      <ul className="divide-y divide-background-200">
        {items.map((work, i) => (
          <li key={work.id}>
            <Link to={`/detail/${work.id}`} className="group flex items-center gap-3 p-3 hover:bg-background-100 transition-colors">
              <span
                className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md font-label text-xs font-bold ${
                  i < 3 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {i + 1}
              </span>
              <span className="w-12 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={work.cover}
                  alt={work.title}
                  title={`${work.title} 影视作品海报`}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-medium text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {work.title}
                </span>
                <span className="block text-xs text-foreground-500 mt-0.5 truncate">
                  {work.year} · {work.genre.join(" / ")}
                </span>
              </span>
              <span className="flex items-center gap-0.5 text-accent-600 font-label text-sm font-semibold shrink-0">
                <i className="ri-star-fill text-xs" />
                {work.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}